module.exports = __webpack_public_path__ + "media/images/tlc-guarantee-ea90e6053785146fa4fbb437f775789f.svg";